// extracted by mini-css-extract-plugin
module.exports = {"dialogFooter":"DialogFooter__dialogFooter___18w5C"};